import React from 'react';
import { Text, View } from 'react-native';

import { PopupMenu } from '../reusable/PopupMenu';
import { AreaType } from 'types/area';

type PropsType = {
  area: AreaType;
  close: () => void;
  open: boolean;
};

const testID = 'AreaPopup';

export function AreaPopup(props: PropsType) {
  const { area, close, open } = props;

  return (
    <PopupMenu
      title={area?.name}
      testID={testID}
      close={() => close()}
      id="area"
      open={open}
    >
      <View>
        {area?.description && (
          <Text testID={`${testID}_description`}>{area?.description}</Text>
        )}
      </View>
    </PopupMenu>
  );
}
